var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "container relative-position",
          staticStyle: { "min-height": "95vh" }
        },
        [
          _vm.resource && _vm.loaded
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "page-tool-bar" },
                    [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          !_vm.readonly
                            ? _c("q-btn", {
                                staticClass: "no-shadow on-left",
                                attrs: {
                                  label: "Add New Record",
                                  color: "secondary",
                                  size: "md",
                                  icon: "add"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push(
                                      _vm.$store.state[_vm.resource]
                                        .clientRoute + "/add"
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _c(
                            "q-btn",
                            {
                              attrs: {
                                round: "",
                                small: "",
                                flat: "",
                                color: _vm.trashed ? "info" : ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTrashed()
                                }
                              }
                            },
                            [
                              _c("q-tooltip", [
                                _vm._v("Show / Hide deleted records")
                              ]),
                              _c("q-icon", { attrs: { name: "delete_sweep" } })
                            ],
                            1
                          ),
                          _vm.resource.trim() === "person" ||
                          _vm.resource === "address" ||
                          _vm.resource === "company"
                            ? _c(
                                "q-btn",
                                {
                                  attrs: {
                                    round: "",
                                    small: "",
                                    flat: "",
                                    color: _vm.getColor(_vm.unapproved)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleUnapproved()
                                    }
                                  }
                                },
                                [
                                  _c("q-tooltip", [
                                    _vm._v(
                                      "Show / Hide records pending approval"
                                    )
                                  ]),
                                  _c("q-icon", {
                                    attrs: { name: "playlist_add_check" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resource.trim() === "person" ||
                          _vm.resource === "company"
                            ? _c(
                                "q-btn",
                                {
                                  attrs: {
                                    round: "",
                                    small: "",
                                    flat: "",
                                    color: _vm.getColor(_vm.guest)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleGuest()
                                    }
                                  }
                                },
                                [
                                  _c("q-tooltip", [
                                    _vm._v("Show / Hide guest records")
                                  ]),
                                  _c("q-icon", { attrs: { name: "help" } })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "q-btn",
                            {
                              attrs: { flat: "", small: "", round: "" },
                              on: { click: _vm.handleRefresh }
                            },
                            [
                              _c("q-tooltip", [
                                _vm._v("Refresh / Reset Saved Settings")
                              ]),
                              _c("q-icon", {
                                attrs: { name: "refresh", color: "secondary" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.azOpen
                        ? _c("az-bar", { attrs: { resource: _vm.resource } })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.trashed
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "page-tool-bar bg-negative q-pa-sm text-white text-center"
                        },
                        [_vm._v("Viewing Deleted Records")]
                      )
                    : _vm._e(),
                  _vm.unapproved === "only"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "page-tool-bar bg-info q-pa-sm text-white text-center"
                        },
                        [_vm._v("Viewing Records Pending Approval")]
                      )
                    : _vm._e(),
                  _vm.unapproved === "both"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "page-tool-bar bg-warning q-pa-sm text-white text-center"
                        },
                        [_vm._v("Viewing Both Approved and Unapproved Records")]
                      )
                    : _vm._e(),
                  _vm.guest === "only"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "page-tool-bar bg-info q-pa-sm text-white text-center"
                        },
                        [
                          _vm._v(
                            "Viewing Guest Records (from event registrations)"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.guest === "both"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "page-tool-bar bg-warning q-pa-sm text-white text-center"
                        },
                        [_vm._v("Viewing Both Guest and Member Records")]
                      )
                    : _vm._e(),
                  _c(_vm.listLayout, {
                    tag: "component",
                    attrs: {
                      resource: _vm.resource,
                      trashed: _vm.trashed,
                      readonly: _vm.readonly
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-pagination", {
                  staticClass: "text-center justify-center",
                  attrs: {
                    value: _vm.storePagination.page,
                    color: "secondary",
                    min: 1,
                    max: _vm.maxPage,
                    "max-pages": 15,
                    "boundary-numbers": "",
                    "boundary-links": ""
                  },
                  on: { change: _vm.changePage }
                })
              ],
              1
            )
          ]),
          _c("q-inner-loading", { attrs: { visible: !_vm.loaded } })
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            value: !!_vm.quickEditId,
            "content-classes": "q-pa-lg",
            "content-css": "min-width: 70%"
          },
          on: { close: _vm.handleCancel }
        },
        [
          _c("div", { staticClass: "row q-pb-md" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("span", { staticClass: "text-primary q-title" }, [
                _vm._v("Quick Edit")
              ])
            ])
          ]),
          _vm.quickEditId
            ? _c(
                "base-form",
                {
                  attrs: {
                    resource: _vm.resource,
                    id: _vm.quickEditId,
                    callback: _vm.handleSave
                  }
                },
                [
                  _c("span", { attrs: { slot: "goback" }, slot: "goback" }, [
                    _c(
                      "div",
                      { staticClass: "q-pa-lg q-mb-lg" },
                      [
                        _c("q-btn", {
                          attrs: {
                            flat: "",
                            label: "Cancel & Close Window",
                            icon: "close"
                          },
                          on: { click: _vm.handleCancel }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }